import { ToggleItem } from '@finn/design-system/atoms/toggle';
import { COMFORT_INSURANCE_ADDON_ID } from '@finn/ua-constants';
import { Features, useIsABVariant } from '@finn/ua-featureflags';
import { formatEuro, useIntl } from '@finn/ui-utils';
import { isNil } from 'lodash';

import { Addon } from '..';
import { getAddonTitle } from '../helpers/addons';
import { InsuranceFeatures } from './InsuranceFeatures';

type Props = {
  addon: Addon;
  insuranceContent: Record<string, any>;
};

export const InsuranceToggleItem = ({ addon, insuranceContent }: Props) => {
  const i18n = useIntl();
  const isMinorDamageExp = useIsABVariant(Features.ExpMinorDamageAddon);

  const coverageFullFallback =
    addon.addon_id === COMFORT_INSURANCE_ADDON_ID ? 50000 : 100000;
  const coveragePartialFallback = 50000;

  return (
    <ToggleItem
      value={addon.addon_id}
      variant="extended"
      title={getAddonTitle(addon)}
      endAdornment={
        <p className="body-14-semibold">
          {addon.pricing.amount.gross === 0
            ? insuranceContent?.modal?.included
            : i18n.formatMessage(insuranceContent?.modal?.priceLine, {
                amount: formatEuro(addon.pricing.amount.gross, i18n),
              })}
        </p>
      }
      description={
        <InsuranceFeatures
          features={[
            i18n.formatMessage(insuranceContent?.modal?.fullCoverage, {
              amount: formatEuro(
                (isNil(addon.attributes?.coverage?.full)
                  ? coverageFullFallback
                  : addon.attributes?.coverage?.full) / 100,
                i18n
              ),
            }),
            i18n.formatMessage(insuranceContent?.modal?.partialCoverage, {
              amount: formatEuro(
                (isNil(addon.attributes?.coverage?.partial)
                  ? coveragePartialFallback
                  : addon.attributes?.coverage?.partial) / 100,
                i18n
              ),
            }),
            addon.attributes?.coverage?.full === 0
              ? i18n.formatMessage(
                  insuranceContent?.modal?.[
                    isMinorDamageExp
                      ? 'zeroDeductibleMinorDamage'
                      : 'zeroDeductibleAdditionalBenefit'
                  ]
                )
              : undefined,
          ]}
        />
      }
    />
  );
};
